interface LabelProps {
  text: string;
  color?: string;
  bg?: string;
}

export const LabelComponent: React.FC<LabelProps> = ({ 
  text, 
  color = "purple-700", 
  bg = "purple-100" 
}) => {
  return (
    <div className={`inline-flex items-center justify-center px-2.5 py-0.5 rounded-md text-sm font-medium ${color} ${bg}`}>
      {text}
    </div>
  );
};